import pako from "pako";

export const DESCRIPTION_COMPRESSION_PREFIX = "gz64:";

export const isCompressed = (str) =>
  typeof str === "string" && str.startsWith(DESCRIPTION_COMPRESSION_PREFIX);

export const decompressDescription = (str = "") => {
  if (!isCompressed(str)) return str; // already plain HTML or empty
  try {
    const base64 = str.slice(DESCRIPTION_COMPRESSION_PREFIX.length);
    const binaryString = atob(base64);
    const bytes = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
    return pako.ungzip(bytes, { to: "string" });
  } catch (err) {
    // Graceful fallback – log and return empty string
    console.error("[DECOMPRESS_DESCRIPTION_ERROR]", err);
    return "";
  }
};
